import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  domains: insights.map((insight) => insight.name)
})

const generateDomainsNameStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateDomainsNameStrategy
